import React from 'react'
import styles from './ModalViewEventAnnouncement.module.scss'
import { ButtonGroup, Eyebrow, Heading, Paragraph } from '~elements'
import { ModalViewEventAnnouncementProps } from '~types'
import { useWindowSize } from '~utils/hooks'

const ModalViewEventAnnouncement = ({
  eyebrowTitle,
  eyebrowBackgroundColor = 'primary',
  headline,
  description,
  disclaimer,
  buttonGroup
}: ModalViewEventAnnouncementProps) => {
  const justification = 'center'
  const { isBreakpoint: isBelowMd } = useWindowSize('md', '<')

  return (
    <div className={styles['view']}>
      {eyebrowTitle && (
        <Eyebrow size='sm' title={eyebrowTitle} backgroundColor={eyebrowBackgroundColor} justify={justification} />
      )}
      {headline && <Heading level={2} title={headline} justify={justification} noMarginTop />}
      {description && <Paragraph text={description} justify={justification} />}
      {buttonGroup && (
        <ButtonGroup
          {...buttonGroup}
          analytics={{
            linkLocation: 'modal',
            linkModule: 'modal_event_announcement',
            parentHeadline: headline
          }}
          layout={isBelowMd ? 'stacked' : 'inline'}
          justifyOverride={justification}
        />
      )}
      {disclaimer && (
        <div className={styles['disclaimer']}>
          <Paragraph text={disclaimer} fontSize='sm' justify={justification} noMarginBottom />
        </div>
      )}
    </div>
  )
}

export default ModalViewEventAnnouncement
